import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionGetArchiveClauseHistoryPathParameters } from 'api/actions/revision-get-archive-clause-history/revision-get-archive-clause-history-path-parameters';
import { RevisionGetArchiveClauseHistoryResponse } from 'api/actions/revision-get-archive-clause-history/revision-get-archive-clause-history-response';

type RevisionGetArchiveClauseHistoryQueryParameters = Record<string, any>;

/**
 * The path of the RevisionGetArchiveClauseHistory action.
 */
export const revisionGetArchiveClauseHistoryActionPath = new SweetPath<
  keyof RevisionGetArchiveClauseHistoryPathParameters
>('/api/revision/archive-clause-history/{revisionId}', { path: '{param}' });

/**
 * Creates a contextualized RevisionGetArchiveClauseHistory actions.
 */
export default function createRevisionGetArchiveClauseHistoryAction(axios: AxiosInstance) {
  return function revisionGetArchiveClauseHistoryAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionGetArchiveClauseHistoryPathParameters;
    query?: RevisionGetArchiveClauseHistoryQueryParameters;
  }) {
    const path = revisionGetArchiveClauseHistoryActionPath.insert(parameters);

    return axios.request<RevisionGetArchiveClauseHistoryResponse, RevisionGetArchiveClauseHistoryResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
